import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import { graphql, useStaticQuery } from 'gatsby'
import CoreFormCTA from 'gatsby-theme-leshen/src/components/FormCTA'
import axios from 'axios'
import _get from 'lodash.get'

const FormCTA = ({ affiliateID, ...props }) => {
  const inputRef = useRef()
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          defaultPromo
        }
      }
    }
  `)
  const defaultPromo = _get(data, 'site.siteMetadata.defaultPromo')
  let promo = affiliateID || defaultPromo
  const JEHandleSubmit = async e => {
    e.preventDefault()
    const url = '/for-homes#/enrollment'

    const zip = _get(inputRef, 'current.state.values.zip')
    if (zip === '') {
      window.location = url
      return
    }

    const response = await axios.get(
      `https://mapi.clearlink.com/postal_code/${zip}`
    )
    const postalCodes = _get(response, 'data.data.postalCodes')
    const { country, province } = postalCodes[0]
      ? postalCodes[0]
      : { country: '', province: '' }

    // If we didn't find a country or province for the postal code, just go to the enrollment page.
    if (country === '' || province === '') {
      window.location = url
      return
    }

    // If the page doesn't have its own affiliate code, use a Texas-specific code or fallback to 'DEFAULT'.
    if (promo === defaultPromo) {
      promo = province === 'TX' ? 'JUSTWEB' : 'DEFAULT'
    }
    const encodedZip = encodeURIComponent(zip)
    window.location = `/for-homes#/enrollment/${country}/${province}/SVC?promoCode=${promo}&postalCode=${encodedZip}`
  }

  return (
    <CoreFormCTA
      {...props}
      onSubmit={JEHandleSubmit}
      ref={inputRef}
      countries={['US', 'CAN']}
    />
  )
}

FormCTA.propTypes = {
  affiliateID: PropTypes.string.isRequired,
}

export default FormCTA
